import { Mail } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function About() {
  usePageMeta({ title: "About Mindful Me — Your calm companion", description: "Why Mindful Me exists: a private, gentle place to check in, spot your patterns and lean on the people who care about you.", path: "/about" });
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-5 pt-16 mm-stagger">
        <div className="flex flex-col sm:flex-row gap-6 items-center sm:items-start">
          <img src="/founder.png" alt="Taylor Baile" className="w-32 h-32 rounded-full object-cover border-4" style={{ borderColor: "var(--mm-surface-light)" }} />
          <div>
            <h1 className="text-4xl font-extrabold">Taylor Baile</h1>
            <p className="text-mm-primary font-semibold mt-1">Founder and Creator</p>
            <p className="text-mm-muted mt-4 leading-relaxed">
              I was burned out, juggling three different apps to track my mood and find coping strategies. Nothing worked together. So I built what I wished existed.
            </p>
          </div>
        </div>
        <div className="mm-card p-8 mt-10">
          <h2 className="text-2xl font-bold">Why I built this</h2>
          <p className="text-mm-muted mt-4 leading-relaxed">
            Mindful Me is the all-in-one mental health companion I needed — mood tracking, AI support, pattern insights, and 100+ coping skills in one place. No more app-hopping. Just one place to check in and figure out what actually helps.
          </p>
          <p className="text-mm-muted mt-4 leading-relaxed">
            Mental health apps shouldn't be complicated. You shouldn't need five different apps to track your mood, learn coping skills, journal your thoughts, and understand your patterns. Mindful Me puts it all in one place — so you can spend less time managing apps and more time actually taking care of yourself.
          </p>
          <a href="mailto:mindfulmeyourcalmcompanion@gmail.com" className="mm-btn-ghost mt-6 max-w-full" data-testid="about-email-link"><Mail size={16} className="shrink-0" /> <span className="truncate">mindfulmeyourcalmcompanion@gmail.com</span></a>
        </div>
      </section>
    </PublicLayout>
  );
}
